import axiosInstance from 'api/axiosInstance';
import getCase from './getCase';

interface UpdateCaseFields {
	Id: number;
	StatusId?: number;
	StatusComment?: string;
}

/**
 * Updates a CANtrack case. The backend requires the full case payload
 * (not just changed fields), so we fetch the current case first and
 * merge the changes into it before sending.
 */
async function updateCase(fields: UpdateCaseFields): Promise<void> {
	// Fetch the full current case data
	const currentCase = await getCase(fields.Id);

	// Convert Keywords and References from objects ({Id, Title}) to int arrays
	// as the backend expects List<int>, not the object format returned by ReadCase
	const keywords = Array.isArray(currentCase.Keywords)
		? currentCase.Keywords.map((k: any) =>
				typeof k === 'object' ? parseInt(k.Id) : parseInt(k),
		  ).filter((id: number) => !isNaN(id) && id > 0)
		: [];
	const references = Array.isArray(currentCase.References)
		? currentCase.References.map((r: any) =>
				typeof r === 'object' ? parseInt(r.Id) : parseInt(r),
		  ).filter((id: number) => !isNaN(id) && id > 0)
		: [];

	// Merge changes into the full payload
	const payload = {
		...currentCase,
		Keywords: keywords,
		References: references,
		...(fields.StatusId !== undefined ? { StatusId: String(fields.StatusId) } : {}),
		...(fields.StatusComment !== undefined ? { StatusComment: fields.StatusComment } : {}),
	};

	const response = await axiosInstance.post('/api/cantrackv3/UpdateCase', {
		payload,
	});

	if (response.status !== 200 || response.data?.Success === false) {
		throw new Error(
			response.data?.Message || `Error updating case: Status ${response.status}`,
		);
	}
}

export default updateCase;
